@file:OptIn(InternalResourceApi::class)

package yendo.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/yendo.shared.generated.resources/"

@delegate:ResourceContentHash(98_546_179)
internal val Res.drawable.apple_logo_black: DrawableResource by lazy {
      DrawableResource("drawable:apple_logo_black", setOf(
        ResourceItem(setOf(), "${MD}drawable/apple_logo_black.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_549_261_970)
internal val Res.drawable.google_g_logo: DrawableResource by lazy {
      DrawableResource("drawable:google_g_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/google_g_logo.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_498_218_967)
internal val Res.drawable.secc_comercio: DrawableResource by lazy {
      DrawableResource("drawable:secc_comercio", setOf(
        ResourceItem(setOf(), "${MD}drawable/secc_comercio.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(584_236_398)
internal val Res.drawable.secc_comida: DrawableResource by lazy {
      DrawableResource("drawable:secc_comida", setOf(
        ResourceItem(setOf(), "${MD}drawable/secc_comida.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_546_514_134)
internal val Res.drawable.secc_envios: DrawableResource by lazy {
      DrawableResource("drawable:secc_envios", setOf(
        ResourceItem(setOf(), "${MD}drawable/secc_envios.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-375_212_183)
internal val Res.drawable.secc_tiendita: DrawableResource by lazy {
      DrawableResource("drawable:secc_tiendita", setOf(
        ResourceItem(setOf(), "${MD}drawable/secc_tiendita.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-697_529_914)
internal val Res.drawable.yendo_logo_vertical_rosa: DrawableResource by lazy {
      DrawableResource("drawable:yendo_logo_vertical_rosa", setOf(
        ResourceItem(setOf(), "${MD}drawable/yendo_logo_vertical_rosa.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("apple_logo_black", Res.drawable.apple_logo_black)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("google_g_logo", Res.drawable.google_g_logo)
  map.put("secc_comercio", Res.drawable.secc_comercio)
  map.put("secc_comida", Res.drawable.secc_comida)
  map.put("secc_envios", Res.drawable.secc_envios)
  map.put("secc_tiendita", Res.drawable.secc_tiendita)
  map.put("yendo_logo_vertical_rosa", Res.drawable.yendo_logo_vertical_rosa)
}
